import { BonusPercentagePerSelection } from '../@types/api';

export const mapPairsToArray = (pairs: [number, number][]): { value: number | null }[] => {
  const result: { value: number | null }[] = [];

  for (const [index, value] of pairs) {
    while (result.length < index - 1) {
      result.push({ value: null });
    }
    result[index - 1] = { value };
  }

  return result;
};

export const toEntryMap = (data?: { value?: number | null }[]): BonusPercentagePerSelection => {
  if (!data) return [];
  return data
    .map<[number, number | undefined] | undefined>((item, index) =>
      item.value !== undefined && item.value !== null ? [index + 1, item.value] : undefined
    )
    .filter((entry): entry is [number, number] => !!entry);
};
